export const SECTION_SIDE_KEYS = {
  left_section: { key: "left_section", label: "Left Section" },
  right_section: { key: "right_section", label: "Right Section" },
};

export const FORM_KEYS = {
  section_side: {
    key: "section_side",
    label: "Choose side of footer",
  },
  text: {
    key: "text",
    label: "Line text",
  },
  link: {
    key: "link",
    label: "Text URL",
  },
};
